<template>
  <div>
    <survey v-if="schemaLoaded" :survey="survey"></survey>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
var Survey = SurveyVue.Survey;

import * as widgets from "surveyjs-widgets";

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);





export default {
  components: {
    Survey
  },
  props:{
      schema: Object,
      displayMode: String
  },
  data() {
    return {
        survey: null,
        schemaLoaded: false
    };
  },
  watch:{
    schema(){
      this.initSchema();
    }
  },
  mounted(){
    this.initSchema();

    var defaultThemeColors = SurveyVue.StylesManager.ThemeColors["default"];
    defaultThemeColors["$main-color"] = this.$vuetify.theme.themes.light.accent;
    defaultThemeColors["$header-color"] = this.$vuetify.theme.themes.light.accent;
    defaultThemeColors["$body-container-background-color"] = "#FFFFFF";
    SurveyVue.StylesManager.applyTheme();

    var vm = this;
    this.survey
    .onComplete
    .add(function(sender){
        vm.$emit('onSurveyComplete', sender.data);
    });
    this.survey
    .onCurrentPageChanged
    .add(function(sender){
        window.scrollTo(0,0);
    });
    var myCss = {
      matrix: {
          root: "table table-striped"
      },
      navigationButton: "button btn-lg"
    };
    this.survey.css = myCss;
    this.survey.locale = 'de';
  },
  methods:{
    initSchema(){
      this.survey = new SurveyVue.Model(this.schema);
      this.survey.mode = this.displayMode;
      this.schemaLoaded = true;
    }
  }
};
</script>

<style>
#app {
  font-family: "Inter", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #216fbd;
}

.sv_body {
  border: 0;
}

.sv_main .sv_custom_header {
  background-color: #f5f5f5;
}

.sv_body {
  display: flex;
  flex-direction: column;
  padding: 2rem 4rem !important;
}

.sv_main.sv_default_css input[type="button"], .sv_default_css button{
  background-color: #fff !important;
}


.sv_nav {
  display: flex !important;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  align-content: flex-end;
}

.sv_prev_btn {
  float: unset !important;
  color: var(--v-gray-base) !important;
  margin-right: .5rem;
  margin-left: .5rem;

}

.sv_next_btn {
  float: unset !important;
  color: var(--v-primary-base) !important;
  margin-right: .5rem;
  margin-left: .5rem;
}


.sv_progress_bar {
  margin-top: 0 !important;
}


.sv_progress > span {
  font-size: .7rem;
}


table {
  margin-top: 2px;
}

.table td {
  border: unset;
}

.sv_q_matrix th > span {
font-size: .7rem;
letter-spacing: -.5px;
}

.sv_page_title{
margin-bottom: 16px;
}

.sv_page_title .sv-string-viewer{
font-size: 1.2rem;
}

.sv_page_title{
color: var(--v-gray-darken3) !important;
/*font-size: 1.5rem !important;*/
}
.sv_main.sv_default_css .sv_progress_bar{
  background-color: var(--v-primary-base) !important;
}
.sv_main.sv_default_css input[type="button"], .sv_default_css button{
  margin-top: 8px;
  min-height: 32px;
}

.sv_main.sv_default_css .sv_body{
  border-color: var(--v-primary-base) !important;
}

.sv_main .sv_container .sv_body .sv_nav{
  border-top: 1px solid var(--v-gray_5-base);
  margin-top: 20px;
}

.sv_main .sv_p_root>.sv_row {
  border: none;
}

.table-striped>tbody>tr:nth-of-type(odd){
  /*background-color: var(--v-primary-lighten5);*/
  height: 4em;
}

.sv_qstn label.sv_q_m_label {
  text-align: center;
}

.sv_main .sv_container .sv_body .sv_p_root table td {
  padding: 1.5em 0.5em;
}

.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix th, .sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix td {
  padding: 1.2em 1em;
}

.sv_main .sv_container .sv_body .sv_p_root table th{
  width:7%;
  vertical-align:middle;
  font-size: .9em;
  background: unset;
}

@media screen and (min-width: 768px) {
  .sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix td {
    min-width: 5em;
  }
}
</style>
